<template>
    <div class="message-item__content--render-text">
        <div class="content-wrap">
            <div ref="text"
                :class="{
                    'text': true,
                    'is-expand': isService && isBeyoungLimitLine && isExpand,
                    'is-retract': isService && isBeyoungLimitLine && !isExpand
                }"
                :style="{background: !isService && color}"
                v-html="contentHTML"
                @click="proxy"></div>
            <div
                v-if="isService && isBeyoungLimitLine"
                class="expand-btn"
                @click.stop="toggleExpand">
                {{isExpand ? '查看全部' : '收起'}}
            </div>
        </div>
    </div>
</template>

<script>
    import expand from '../../mixins/expand'
    import { sendMessage } from '@/utils/message_send'
    import { MESSAGE_NAME } from '@/constants/message'

    const CLICK_CLASSNAME = 'is-link'

    export default {
        name: 'MessageContentRenderText',
        mixins: [
            expand
        ],
        props: {
            text: {
                type: String,
                required: true,
                validator (value) {
                    return value.trim() !== ''
                }
            }
        },
        computed: {
            contentHTML () {
                return this.strToHtml(this.text)
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            }
        },
        methods: {
            strToHtml (str) {
                const result = str
                    .replace(/\r\n/g, '<br>')
                    .replace(/\n/g, '<br>')
                    .replace(/<click>(.*?)<\/click>/g, `<span class="${CLICK_CLASSNAME}">$1</span>`)
                return result
            },
            proxy (event) {
                const target = event.target
                if (target.className === CLICK_CLASSNAME) {
                    sendMessage({
                        type: 'base',
                        detailType: MESSAGE_NAME.TEXT,
                        content: target.innerText
                    })
                    this.$eventBus.$emit('showinputstatus', {is_input:true})
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/content_text";

    /deep/ .is-link {
        display: inline-block;
        color: $primary-color;
        vertical-align: top;
        margin: 6px 0;
        cursor: pointer;
        &:active {
            color: $primary-color-darken;
        }
    }

    .message-item--service {
        .text {
            color: $primary-text-color;
            background-color:  #ffffff;
            box-shadow: $primary-box-shadow;
            @include radius(.25, .5, .5, .5);

            &:active {
                background-color: darken(#ffffff, 7%)
            }
        }
    }

    .content-wrap {
        position: relative;
    }
</style>
